import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { WelcomePopup } from './components/updates/WelcomePopup';
import { InstallPrompt } from './components/updates/InstallPrompt';
import { AIAssistant } from './components/ai/AIAssistant';

// Main Portal Pages
import HomePage from './pages/portal/HomePage';
import AboutPage from './pages/portal/AboutPage';
import ToolsPage from './pages/portal/ToolsPage';
import ConsultationsPage from './pages/portal/ConsultationsPage';
import LectureDesignPage from './pages/portal/LectureDesignPage';
import ResourcesPage from './pages/portal/ResourcesPage';
import ContactPage from './pages/portal/ContactPage';
import GuidedJourneyPage from './pages/portal/GuidedJourneyPage';
import TirageCartes from './pages/portal/TirageCartes';

// Auth Pages
import Login from './pages/barometre/Login';
import Register from './pages/barometre/Register';

// Baromètre Pages
import Welcome from './pages/barometre/Welcome';
import Dashboard from './pages/barometre/Dashboard';
import Profile from './pages/barometre/Profile';
import Assessment from './pages/barometre/Assessment';
import History from './pages/barometre/History';
import Admin from './pages/barometre/Admin';
import Settings from './pages/barometre/Settings';
import LegalNotice from './pages/LegalNotice';
import FAQ from './pages/help/FAQ';
import Contact from './pages/help/Contact';
import Mission from './pages/about/Mission';
import Forum from './pages/forum/Forum';
import Category from './pages/forum/Category';
import Post from './pages/forum/Post';
import NewDiscussion from './pages/forum/NewDiscussion';

// Projector Watch Pages
import ProjectorWatchPage from './pages/projector-watch/ProjectorWatchPage';
import ProjectorWatchAdminDashboard from './pages/projector-watch/ProjectorWatchAdminDashboard';
import ProjectorWatchUserDashboard from './pages/projector-watch/ProjectorWatchUserDashboard';
import TestAntigravite from './pages/projector-watch/TestAntigravite';
import CallbackPage from './pages/projector-watch/CallbackPage';

// Align Pages
import AlignPage from './pages/align/AlignPage';

// Admin Pages
import AdminPage from './pages/Admin';

import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Container } from './components/ui/container';

function App() {
  const [showWelcome, setShowWelcome] = useState(true);

  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <ThemeProvider>
            <div className="min-h-screen flex flex-col transition-colors duration-500 ease-in-out bg-gradient-to-br from-purple-50 via-pink-50 to-purple-100 overflow-x-hidden">
              {showWelcome && <WelcomePopup onClose={() => setShowWelcome(false)} />}
              <InstallPrompt />
              <AIAssistant />
              <Navbar />
              <main className="flex-grow pt-14 overflow-x-hidden">
                <Container className="py-4 sm:py-6">
                  <Routes>
                    {/* Portal Routes */}
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/tools" element={<ToolsPage />} />
                    <Route path="/consultations" element={<ConsultationsPage />} />
                    <Route path="/lecture-design" element={<LectureDesignPage />} />
                    <Route path="/parcours" element={<GuidedJourneyPage />} />
                    <Route path="/tirage-cartes" element={<TirageCartes />} />
                    <Route path="/resources" element={<ResourcesPage />} />
                    <Route path="/contact-us" element={<ContactPage />} />
                    
                    {/* Auth Routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    
                    {/* Baromètre Routes */}
                    <Route path="/barometre" element={<Welcome />} />
                    <Route path="/barometre/dashboard" element={<Dashboard />} />
                    <Route path="/barometre/login" element={<Login />} />
                    <Route path="/barometre/register" element={<Register />} />
                    <Route path="/barometre/profile" element={<Profile />} />
                    <Route path="/barometre/assessment" element={<Assessment />} />
                    <Route path="/barometre/history" element={<History />} />
                    <Route path="/barometre/admin" element={<Admin />} />
                    <Route path="/barometre/settings" element={<Settings />} />
                    
                    {/* Projector Watch Routes */}
                    <Route path="/projector-watch" element={<ProjectorWatchPage />} />
                    <Route path="/projector-watch/admin" element={<ProjectorWatchAdminDashboard />} />
                    <Route path="/projector-watch/dashboard" element={<ProjectorWatchUserDashboard />} />
                    <Route path="/projector-watch/test-antigravite" element={<TestAntigravite />} />
                    <Route path="/projector-watch/callback" element={<CallbackPage />} />
                    
                    {/* Align Routes */}
                    <Route path="/align" element={<AlignPage />} />
                    
                    {/* Admin Routes */}
                    <Route path="/admin" element={<AdminPage />} />
                    
                    {/* Common Routes */}
                    <Route path="/mentions-legales" element={<LegalNotice />} />
                    <Route path="/help/faq" element={<FAQ />} />
                    <Route path="/help/contact" element={<Contact />} />
                    <Route path="/about/mission" element={<Mission />} />
                    <Route path="/forum" element={<Forum />} />
                    <Route path="/forum/category/:slug" element={<Category />} />
                    <Route path="/forum/post/:id" element={<Post />} />
                    <Route path="/forum/new" element={<NewDiscussion />} />
                  </Routes>
                </Container>
              </main>
              <Footer />
              <Toaster />
            </div>
          </ThemeProvider>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;